import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Shield, Users, AlertCircle } from 'lucide-react';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ paddingTop: '80px' }} className="bg-light">
      <div className="container py-5">
        {/* Back Button */}
        <Link
          to="/"
          className="btn btn-link text-primary text-decoration-none mb-4 p-0"
        >
          <ArrowLeft className="me-2" size={16} />
          Back to Home
        </Link>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card border-0 shadow-lg">
              <div className="card-header bg-primary text-white p-4">
                <div className="d-flex align-items-center gap-3">
                  <FileText size={32} />
                  <div>
                    <h1 className="h2 mb-1">Terms & Conditions</h1>
                    <p className="mb-0 opacity-90">Last updated: JULY, 2025</p>
                  </div>
                </div>
              </div>

              <div className="card-body p-5">
                <div className="alert alert-info d-flex align-items-start gap-3">
                  <AlertCircle size={20} className="mt-1" />
                  <div>
                    <strong>Important Notice:</strong> By using Grad Vikalp's services, you agree to these terms and conditions. Please read them carefully.
                  </div>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3 d-flex align-items-center gap-2">
                    <Shield size={20} />
                    1. Acceptance of Terms
                  </h2>
                  <p className="text-muted">
                    By accessing and using Grad Vikalp's website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                  </p>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">2. Service Description</h2>
                  <p className="text-muted mb-3">
                    Grad Vikalp provides college guidance services including:
                  </p>
                  <ul className="text-muted">
                    <li>College search and comparison tools</li>
                    <li>Verified student reviews and ratings</li>
                    <li>Personalized college recommendation lists</li>
                    <li>Educational blog content and guidance</li>
                    <li>Student mentorship connections</li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3 d-flex align-items-center gap-2">
                    <Users size={20} />
                    3. User Responsibilities
                  </h2>
                  <div className="text-muted">
                    <p className="mb-3">As a user of our services, you agree to:</p>
                    <ul>
                      <li>Provide accurate and truthful information</li>
                      <li>Use the service for lawful purposes only</li>
                      <li>Not share your account credentials with others</li>
                      <li>Respect intellectual property rights</li>
                      <li>Not post false or misleading reviews</li>
                      <li>Maintain confidentiality of other users' personal information</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">4. Personalized List Service</h2>
                  <div className="text-muted">
                    <p className="mb-3">Our personalized college list service:</p>
                    <ul>
                      <li>Provides recommendations based on your academic profile and preferences</li>
                      <li>Uses historical data and current admission trends</li>
                      <li>Does not guarantee admission to any college</li>
                      <li>Should be used as guidance only, not as the sole basis for college selection</li>
                      <li>May require payment as specified on our pricing page</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">5. Payment Terms</h2>
                  <div className="text-muted">
                    <ul>
                      <li>All payments are processed securely through Razorpay</li>
                      <li>Prices are clearly displayed before purchase</li>
                      <li>Refunds are subject to our refund policy</li>
                      <li>We reserve the right to change pricing with notice</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">6. Intellectual Property</h2>
                  <p className="text-muted">
                    All content on Grad Vikalp, including text, graphics, logos, images, and software, is the property of Grad Vikalp and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.
                  </p>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">7. Disclaimer of Warranties</h2>
                  <div className="text-muted">
                    <p className="mb-3">Grad Vikalp provides services "as is" without warranties of any kind. We specifically disclaim:</p>
                    <ul>
                      <li>Accuracy of college information and cutoff data</li>
                      <li>Guarantee of admission to any institution</li>
                      <li>Completeness of information provided</li>
                      <li>Availability of services at all times</li>
                    </ul>
                  </div>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">8. Limitation of Liability</h2>
                  <p className="text-muted">
                    Grad Vikalp shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of our services.
                  </p>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">9. Privacy</h2>
                  <p className="text-muted">
                    Your privacy is important to us. Please review our Privacy Policy, which also governs your use of our services, to understand our practices.
                  </p>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">10. Termination</h2>
                  <p className="text-muted">
                    We may terminate or suspend your account and access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                  </p>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">11. Changes to Terms</h2>
                  <p className="text-muted">
                    We reserve the right to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
                  </p>
                </div>

                <div className="mb-5">
                  <h2 className="h4 fw-bold text-primary mb-3">12. Contact Information</h2>
                  <div className="text-muted">
                    <p className="mb-3">If you have any questions about these Terms & Conditions, please contact us:</p>
                    <ul className="list-unstyled">
                      <li><strong>Email:</strong> vikalpgrad@gmail.com</li>
                      <li><strong>Phone:</strong> +91 7568377278</li>
                      <li><strong>Address:</strong> Jaipur, India</li>
                    </ul>
                  </div>
                </div>

                <div className="alert alert-warning">
                  <strong>Note:</strong> These terms and conditions are effective as of JULY 2025. Continued use of our services after any changes constitutes acceptance of the new terms.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;